import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4 24C4 12.954 12.953 4 24 4s20 8.953 20 20-8.953 20-20 20C12.954 44 4 35.047 4 24m2 0a17.93 17.93 0 0 0 4.576 11.992c.004.006 25.44-25.396 25.435-25.4A17.93 17.93 0 0 0 24 6C14.057 6 6 14.058 6 24m18.01 17.992c9.943 0 18-8.058 18-18 0-4.607-1.73-8.809-4.575-11.992-.005-.005-25.44 25.396-25.435 25.4a17.93 17.93 0 0 0 12.01 4.592",
      clipRule: "evenodd"
    }
  )
);
var SvgBlockedOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var BlockedOutlined_default = SvgBlockedOutlined;

export { BlockedOutlined_default as default };
